import angular from 'angular';

angular
    .module('dashboard')

    .controller('FolderDetailsCtrl', [
        '$scope',
        '$uibModal',
        '$state',
        'FolderService',
        'folder',
        'Files',
        '$translate',
        function($scope, $uibModal, $state, FolderService, folder, Files, $translate) {
            $scope.container = null;
            $scope.folder = folder;
            $scope.folder.$promise.then(function(data) {
                $scope.container = data.container;
            });
            $scope.folderSvc = FolderService;
            $scope.modalInstance = null;
            $scope.modalInstanceKO = null;
            $scope.containerPopupTitle = null;
            $scope.containerPopup = null;
            $scope.endContainerPopup = null;
            $scope.closeAppear = false;
            $scope.$translate = $translate;
            $scope.auditLog = null;

            $scope.back = function() {
                $state.go('folders', { keepFilter: true });
            };

            // Affichage de la fenêtre de detail du container d'une enveloppe.
            $scope.openContainerPopup = function() {
                return $uibModal
                    .open({
                        templateUrl: require('../envelope/envelope-container-popup.html'),
                        controller: 'EnvelopeContainerCtrl',
                        resolve: {
                            container: function() {
                                return $scope.container;
                            }
                        }
                    })
                    .result.then(
                        function() {},
                        function() {}
                    );
            };

            // Affichage de la fenêtre rejeu validation signature.
            $scope.openRetryValidationPopup = function() {
                const modalInstance = $uibModal.open({
                    component: 'folderRetryValidation',
                    resolve: {
                        containerTitle: function() {
                            return $scope.containerPopupTitle;
                        },
                        container: function() {
                            return $scope.containerPopup;
                        },
                        endContainer: function() {
                            return $scope.endContainerPopup;
                        },
                        closeAppear: function() {
                            return $scope.closeAppear;
                        }
                    },
                    backdrop: 'static',
                    keyboard: false
                });
                modalInstance.result.then(
                    function() {},
                    function() {}
                );
                return modalInstance;
            };

            // Permet de télécharger un fichier
            $scope.openFIle = function(fileId) {
                return Files.download(fileId);
            };

            // Permet de rejouer la verificatioin de signature
            $scope.hasValidation = function(status) {
                return status === 'VALIDATION';
            };

            $scope.retrySignatureValidation = function(folderId) {
                const auditLogPromise = $scope.getAuditLogByFolder(folderId);
                auditLogPromise.then(auditLog => {
                    if (auditLog.errorStatusCode !== '0') {
                        $scope.containerPopupTitle = 'dashboard.folder.popup.validation.title';
                        $scope.containerPopup = 'dashboard.folder.popup.validation.retryActif';
                        $scope.endContainerPopup = 'dashboard.folder.popup.validation.courtesy';
                        $scope.closeAppear = false;
                        $scope.modalInstance = $scope.openRetryValidationPopup();
                        $scope.folderSvc.retrySignatureValidation();
                        $scope.pullingForRetrySignature(folderId);
                    } else {
                        $scope.reloadfolder(folderId);
                    }
                });
            };

            $scope.retrySignatureValidationKO = function(auditLog) {
                $scope.containerPopupTitle = 'dashboard.folder.popup.validation.titleKO';
                $scope.containerPopup = $scope.$translate.instant('dashboard.folder.popup.validation.KO', {
                    CodeErreur: auditLog.errorStatusCode,
                    LibelErreur: auditLog.motif
                });
                $scope.endContainerPopup = '';
                $scope.closeAppear = true;
                $scope.modalInstanceKO = $scope.openRetryValidationPopup();
            };

            $scope.pullingForRetrySignature = function(folderId) {
                let time = 0;
                const reTrySignInterval = setInterval(function() {
                    $scope.getAuditLogByFolder(folderId).then(auditLogRec => {
                        $scope.auditLog = auditLogRec;
                        time += 10000;
                        if (auditLogRec.errorStatusCode === '0') {
                            clearInterval(reTrySignInterval);
                            $scope.modalInstance.dismiss();
                            $scope.reloadfolder(folderId);
                        }
                    });

                    if (time >= 60000) {
                        clearInterval(reTrySignInterval);
                        $scope.modalInstance.dismiss();
                        $scope.retrySignatureValidationKO($scope.auditLog);
                    }
                }, 10000);
            };

            $scope.getAuditLogByFolder = function(folderId) {
                return $scope.folderSvc.getAuditLogByFolder({ folderId: folderId }).$promise;
            };

            $scope.reloadfolder = function(folderId) {
                $scope.folderSvc.get({ folderId: folderId }).$promise.then(function(folder) {
                    $scope.folder = folder;
                    $scope.folder.$promise.then(function(data) {
                        $scope.container = data.container;
                    });
                });
            };
        }
    ]);
